// extracted by mini-css-extract-plugin
export default {"values":"h9mix","values--max":"aVKO0","item":"ZE1F7","values--wide":"kB6zN","values--label":"Mj5ee","values--half":"gFGxZ","values--cut":"EGu2i"};